export const loadMapApi = (googleMapKey: string) => {
  const mapsURL = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=places,drawing,geometry`;
  const scripts = document.getElementsByTagName('script');
  // Go through existing script tags, and return google maps api tag when found.
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src?.indexOf(mapsURL) === 0) {
      return scripts[i];
    }
  }

  const googleMapScript = document.createElement('script');
  googleMapScript.src = mapsURL;
  googleMapScript.async = true;
  googleMapScript.defer = true;
  // Mark as essential/functional for Termly - Google Maps is required for address input functionality
  googleMapScript.setAttribute('data-category', 'essential');
  window.document.body.appendChild(googleMapScript);

  return googleMapScript;
};
